import React, {Component} from 'react';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';

class FileUpload extends Component {
    constructor() {
        super();
        this.state = {files: []}
    }

    render() {
        return (
            <div className='wrapper row  mb-2'>
                    <Dropzone  onDrop={this.props.onDrop} className='attach-box-v2' accept={this.props.accept}>
                        <label className='h7' htmlFor='attach1'>
                            Arrastra tu archivo aquí o<span className='btn-link'> seleccione de tu computador</span>
                        </label>
                    </Dropzone>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

FileUpload.defaultProps = {};
export default connect(mapStateToProps,
    {})(FileUpload);



// WEBPACK FOOTER //
// ./src/pages/Comun/FileUpload.js